const body = document.body;

const submitTime = (selector) => {
  const formSubmitElements = body.querySelectorAll(selector || `.form__contactSubmit`);

  if (formSubmitElements) {
    formSubmitElements.forEach((element) => {
      const inputTimeHidden = () => {
        const input = document.createElement(`input`);
        input.name = `browserDate`;
        input.type = `hidden`;
        input.value = new Date();
        return input;
      };

      const inputURLHidden = () => {
        const input = document.createElement(`input`);
        input.name = `url`;
        input.type = `hidden`;
        input.value = window.location.href;
        return input;
      };

      element.addEventListener(`submit`, () => {
        element.appendChild(inputTimeHidden());
        element.appendChild(inputURLHidden());

        const gaEvent = element.dataset.gaEvent || 'event-to-ga';
        const gaEventCategory = element.dataset.gaEventCategory || 'click';
        const gaEventAction = element.dataset.gaEventAction || 'sendform';

        if ('dataLayer' in window) {
          // send event to GTM
          dataLayer.push({
            'event': gaEvent,
            'eventCategory': gaEventCategory,
            'eventAction': gaEventAction
          });
        }
      });
    });
  }
};

window.submitTime = submitTime;
